import { combineReducers } from 'redux';
import { QuestionTypes, BuildingTypes } from '../../action_types';
import { arrayToObject, removeItem, insertItem, updateObjectInArray } from '@app/utils/helpers';

function ui(state = [], action) {
  switch (action.type) {
    case QuestionTypes.GET_QUESTIONS_SUCCESS:
      return action.data[action.question_type] || [];
    case QuestionTypes.CREATE_QUESTION_SUCCESS:
      return insertItem(state, action.data);
    case QuestionTypes.UPDATE_QUESTION_SUCCESS:
      return updateObjectInArray(state, action.data);
    case QuestionTypes.DELETE_QUESTION_SUCCESS:
      return removeItem(state, action.id);
    default:
      return state;
  }
}

function questionOrder(state = [], action) {
  switch (action.type) {
    case BuildingTypes.GET_BUILDING_SUCCESS:
    case BuildingTypes.UPDATE_BUILDING_SUCCESS:
      return action.data.survey_questions || [];
    case QuestionTypes.CREATE_QUESTION_SUCCESS:
      return [...state, action.data.id];
    case QuestionTypes.DELETE_QUESTION_SUCCESS:
      return removeItem(state, parseInt(action.id));
    default:
      return state;
  }
}

export default combineReducers({
  ui,
  questionOrder,
});
